// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HeartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HeartIcon" ref={forwardedRef} {...props}>
      <path d="M3.523 4.327c.92-.828 2.18-1.257 3.5-1.006 1.06.202 2.088.827 2.98 1.905.89-1.078 1.918-1.703 2.978-1.904 1.32-.25 2.578.178 3.497 1.007 1.865 1.682 2.295 4.915-.305 7.688l-6.17 6.58-6.167-6.579C1.227 9.243 1.655 6.01 3.523 4.327m3.22.468C5.925 4.639 5.131 4.897 4.527 5.44c-1.181 1.063-1.69 3.324.403 5.55v.001l5.073 5.411 5.075-5.411c2.083-2.222 1.576-4.484.395-5.549-.604-.545-1.396-.802-2.212-.647-.815.154-1.767.743-2.622 2.111l-.636 1.018-.636-1.018C8.513 5.54 7.56 4.95 6.743 4.795" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HeartIcon = /* @__PURE__ */ Object.assign(HeartIconComponent, {
  displayName: 'HeartIcon',
});
